import styled from 'styled-components'

import { useClock } from 'hooks'

import { Box } from './box'

const Time = styled.div`
  ${({ theme: { colors } }) => `
  font-size: clamp(1rem, 10vw + 1rem, 25rem);
  font-weight: 600;
  color: ${colors('text')};
    `}
`

export const Clock = () => {
  const time = useClock()

  return (
    <Box>
      <Time>
        {time[0][0]}:{time[0][1]}
      </Time>
    </Box>
  )
}
